import { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { lazy } from '@loadable/component';
import Loading from '../app/atoms/Loading';
import Profile from '../app/pages/Profile';
import MyTrips from '../app/pages/MyTrips/MyTrips';
import WithTracker from './WithTracker';

const Pages = (props: any) => {
  const { path } = props.match;
  return (
    <Suspense
      fallback={
        <div>
          <Loading force={true} />
        </div>
      }
    >
      <Switch>
        <Route path="/profile" component={WithTracker(Profile)} />
        <Route path="/my-trips" component={WithTracker(MyTrips)} />
        <Route exact path={`${path}results`} component={WithTracker(lazy(() => import('app/pages/Result')))} />
        <Route exact path={`${path}details/:id`} component={WithTracker(lazy(() => import('app/pages/Details')))} />
        <Route exact path={`${path}checkout/:id`} component={WithTracker(lazy(() => import('app/pages/Checkout/Checkout')))} />
        <Route
          exact
          path={`${path}booking-confirm/:bookingReference`}
          component={WithTracker(lazy(() => import('app/pages/BookingConfirmation/BookingConfirmation')))}
        />
        <Route exact path={`${path}gallery/:id`} component={WithTracker(lazy(() => import('app/pages/Gallery')))} />
        <Route path={`${path}`} component={WithTracker(lazy(() => import('app/pages/Home')))} />
      </Switch>
    </Suspense>
  );
};

export default Pages;
